import React, { useContext } from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import './productlist.css'
import { toast } from 'react-toastify';
import { GlobalState } from '../../../../GlobalState';

export default function InvoiceProductList({
    product, index, handleRemoveProductClick, onCalculateDiscount, onCalculateTotal }) {

    const [qty, setQty] = useState("1");
    const [discount, setDiscount] = useState("");
    const [total, setTotal] = useState(0);

    const state = useContext(GlobalState);
    const [stocks] = state.stockAPI.stocks;

    const qtyOnchange = (e, productId) => {
        if (e.target.value <= 0) {
            toast.warn("Can't add quantity below or equal to 0.")
        } else {
            const availableQuantity = stocks.filter(stock => stock.productId === productId);

            if (availableQuantity[0].qty <= e.target.value) {
                setQty(e.target.value);
                onCalculateTotal(product.unit_price, e.target.value, productId)
            } else {
                toast.warn("You can't add more than the existing quantity")
            }
        }
    }

    const discountOnchange = (e, productId) => {
        if (e.target.value < 0) {
            toast.warn("Can't add quantity below or equal to 0.")
        } else {
            setDiscount(e.target.value);
            onCalculateDiscount(e, productId);
        }
    }

    useEffect(() => {

        const totalValue = parseFloat(qty) * parseFloat(product.unit_price);
        const netValue = totalValue - parseFloat(discount || 0);

        setTotal(netValue);
    }, [qty, discount, total, stocks])

    const handleFocus = (event) => event.target.select();

    return (
        <tbody className='tbody-items'>
            <tr>
                <td>{index}</td>
                <td><img src={product.img} alt="dummy" /></td>
                <td>{product.name}</td>
                <td>
                    <input
                        type="number"
                        name="qty"
                        id="qty"
                        value={qty || "1"}
                        onChange={(e) => qtyOnchange(e, product.id)}
                    />
                </td>
                <td>Rs. {product.unit_price}</td>
                <td>
                    <input
                        type="text"
                        name="discount"
                        id="discount"
                        value={discount || "0"}
                        onChange={(e) => discountOnchange(e, product.id)}
                        onFocus={handleFocus}
                    />
                </td>
                <td>{total}</td>
                <td><button><i className='uil uil-trash-alt' onClick={(e) => handleRemoveProductClick(e, index)}></i></button></td>
            </tr>
        </tbody>
    )
}
